import axiosClient from "./axiosClients";
import queryString from "query-string";

const uri = "/payments";

class PaymentApi {
  getFeeShip = (receiverProvince, receiverDistrict, weight, value) => {
    const senderProvince = process.env.REACT_APP_SENDER_PROVINCE;
    const senderDistrict = process.env.REACT_APP_SENDER_DISTRICT;

    const params = queryString.stringify({
      senderProvince,
      senderDistrict,
      receiverProvince,
      receiverDistrict,
      weight,
      value,
    });

    const url = `${uri}/feeShip?${params}`;

    return axiosClient.get(url);
  };

  paymentOffice(cart) {
    const url = `${uri}/payment-office`;

    return axiosClient.post(url, cart);
  }

  paymentOnline(cart) {
    const url = `${uri}/payment-online`;

    return axiosClient.post(url, cart);
  }
}
const paymentApi = new PaymentApi();
export default paymentApi;
